import { useToast as chakraToast, UseToastOptions } from "@chakra-ui/toast";

interface ToastProps {
  openTime?: "normal" | "short" | "long";
}

export const useToast = () => {
  return chakraToast({
    title: "Something went wrong",
    description: "Please refresh the page.",
    position: "top",
    status: "info",
    isClosable: true,
    variant: "solid"
  });
};
